import classNames from "classnames";
import { useTranslation } from "features/translations";
import { Icon, ImageLite, PageLink, Paragraph } from "shared/components";

import styles from "./DefaultItem.module.scss";

export const DefaultItem = ({ item, itemsAmount }) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(styles.item, {
        [styles.five]: itemsAmount === "five",
      })}
    >
      <PageLink directory="events" slug={item.slug} className={styles.wrapper}>
        <ImageLite image={item.previewImage} className={styles.image} />
        <div className={styles.block}>
          <Paragraph className={styles.date} color="light" appearance="bigger">
            {item.eventTimeDescription}
          </Paragraph>

          <div>
            <Paragraph className={styles.category} color="light" uppercase>
              {item.eventCategories?.[0]?.title ?? ""}
            </Paragraph>
            <Paragraph className={styles.title} color="light" appearance="bold">
              {item.title}
            </Paragraph>
            <div className={styles.details}>
              <Paragraph color="light" className={styles.place}>
                <Icon className={styles.icon} name="message" />
                {t(item.eventType)}, {item.eventPlace}
              </Paragraph>
              <Paragraph color="light" className={styles.price}>
                <Icon className={styles.icon} name="tag" />
                {item.eventPrice}
              </Paragraph>
            </div>
          </div>
        </div>
      </PageLink>
    </div>
  );
};
